import { inject, Service } from '@angular/core';

import { MessageService } from '@openng/optimus-ui/api';

import { CorrelationIdError } from 'src/app/models/correlation-id-error';
import { environment } from 'src/environments/environment';

/**
 * Shows notifications to the user in a consistent format.
 */
@Service()
export class NotificationService {
	/** To show toasts. */
	private messageService = inject(MessageService);

	/**
	 * Shows an error toast.
	 * If the error is a {@link CorrelationIdError}, its reference ID message is appended, so the user can provide it when contacting support.
	 * @param summary Short description of what failed.
	 * @param error Error that occurred, if any.
	 * @param detail User-facing description of the failure, if any.
	 */
	public notifyError(summary: string, error?: unknown, detail?: string): void {
		const correlationIdMessage = error instanceof CorrelationIdError ? error.correlationIdMessage : undefined;

		this.messageService.add({
			severity: 'error',
			life: environment.errorMessageDuration,
			summary,
			detail: [detail, correlationIdMessage].filter(part => !!part).join(' ') || undefined,
		});
	}
}
